import { render, staticRenderFns } from "./NotificationSearch.vue?vue&type=template&id=2657d9ee&"
import script from "./NotificationSearch.vue?vue&type=script&lang=js&"
export * from "./NotificationSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports